import { LOCALE_MAP_TO_I18N_TS } from "constants/lang";
import { useI18n } from "hooks/i18n/i18n";
import { getLanguageType } from "i18n/weglot";
import { adminActions } from "modules/admin";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

/**
 * 初回ロード時、cookieから取得した言語をi18nにセットする.
 */
export const LanguageInitializer: FcWithoutChildren = () => {
  const { i18n } = useI18n();
  const dispatch = useDispatch();

  useEffect(() => {
    const languageType = getLanguageType();
    void i18n.changeLanguage(LOCALE_MAP_TO_I18N_TS[languageType.value]);
    dispatch(adminActions.setI18nLang(languageType.value));
    // NOTE: 初回マウント時のみ実行したいため、依存配列は空
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
